import { createAction } from "@reduxjs/toolkit";
import { utilsConstants } from "../constants";

export const setShowLoader = createAction(
  utilsConstants.SET_SHOW_LOADER,
  (payload) => ({ payload })
);
